import type { UrqlOperationContext } from 'lib/urqlClient';
import { useMemo } from 'react';

// A stable reference keeps urql from re-executing the query on every render.
export const useNonSuspendingContext = (context: UrqlOperationContext) =>
  useMemo(() => ({ ...context, suspense: false }), [context]);
